// import { createSlice } from "@reduxjs/toolkit";
// import images from "../images.config";

// const initialState = {
//   items: [
//     {
//       id: "ORD123",
//       name: "Floral Maxi Dress",
//       size: "M",
//       status: "Shipped",
//       price: 1999,
//       payment: "Credit Card",
//       image: images.collection2,
//     },
//     {
//       id: "ORD456",
//       name: "Elegant Evening Gown",
//       size: "L",
//       status: "Delivered",
//       price: 2499,
//       payment: "Cash on Delivery",
//       image: images.collection1,
//     },
//   ],
// };

// const ordersSlice = createSlice({
//   name: "orders",
//   initialState,
//   reducers: {},
// });

// export default ordersSlice.reducer;


// import { createSlice } from "@reduxjs/toolkit";
// import images from "../images.config";

// const initialState = {
//   items: [
//     {
//       id: "ORD123",
//       status: "Shipped",
//       payment: "Credit Card",
//       items: [
//         {
//           name: "Floral Maxi Dress",
//           size: "M",
//           price: 1999,
//           image: images.collection2,
//           selectedSize: "M",
//           selectedColor: "Red",
//           quantity: 1,
//           discountedPrice: 1800,
//           paymentMethod: "Credit Card",
//         },
//       ],
//     },
//     {
//       id: "ORD456",
//       status: "Delivered",
//       payment: "Cash on Delivery",
//       items: [
//         {
//           name: "Elegant Evening Gown",
//           size: "L",
//           price: 2499,
//           image: images.collection1,
//           selectedSize: "L",
//           selectedColor: "Blue",
//           quantity: 1,
//           discountedPrice: 2300,
//           paymentMethod: "Cash on Delivery",
//         },
//       ],
//     },
//   ],

// };

// const ordersSlice = createSlice({
//   name: "orders",
//   initialState,
//   reducers: {
//     placeOrder: (state, action) => {
//       state.items.push(action.payload);
//     },

//     setPaymentMethod: (state, action) => {
//       state.paymentMethod = action.payload;
//     },

//     setOrderSummary: (state, action) => {
//       state.orderSummary = action.payload;
//     },
//   },
// });

// export const { placeOrder, setPaymentMethod, setOrderSummary } = ordersSlice.actions;

// export default ordersSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";
import images from "../images.config";

const initialState = {
  items: [
    {
      id: "ORD123",
      status: "Shipped",
      paymentMethod: "Credit Card",
      items: [
        {
          name: "Floral Maxi Dress",
          price: 1999,
          image: images.collection2,
          selectedSize: "M",
          selectedColor: "Red",
          quantity: 1,
          discountedPrice: 1800, // After discount
        },
      ],
      billingAddress: {
        firstName: "John",
        lastName: "Doe",
        email: "johndoe@example.com",
        phone: "9876543210",
        houseNumber: "123",
        area: "Main Street",
        city: "Mumbai",
        state: "Maharashtra",
        pincode: "400001",
        country: "India",
      },
      shippingAddress: {
        firstName: "John",
        lastName: "Doe",
        email: "johndoe@example.com",
        phone: "9876543210",
        houseNumber: "123",
        area: "Main Street",
        city: "Mumbai",
        state: "Maharashtra",
        pincode: "400001",
        country: "India",
      },
      couponDiscount: 100,
      gst: 324, // 18% GST of (Subtotal - Coupon Discount)
      totalPrice: 2024, // (Subtotal - Coupon Discount) + GST
    },
    {
      id: "ORD456",
      status: "Delivered",
      paymentMethod: "Cash on Delivery",
      items: [
        {
          name: "Elegant Evening Gown",
          price: 2499,
          image: images.collection1,
          selectedSize: "L",
          selectedColor: "Blue",
          quantity: 1,
          discountedPrice: 2300,
        },
      ],
      billingAddress: {
        firstName: "Jane",
        lastName: "Smith",
        email: "janesmith@example.com",
        phone: "9876543211",
        houseNumber: "456",
        area: "Park Avenue",
        city: "Delhi",
        state: "Delhi",
        pincode: "110001",
        country: "India",
      },
      shippingAddress: {
        firstName: "Jane",
        lastName: "Smith",
        email: "janesmith@example.com",
        phone: "9876543211",
        houseNumber: "456",
        area: "Park Avenue",
        city: "Delhi",
        state: "Delhi",
        pincode: "110001",
        country: "India",
      },
      couponDiscount: 150,
      gst: 387, // 18% GST of (Subtotal - Coupon Discount)
      totalPrice: 2537, // (Subtotal - Coupon Discount) + GST
    },
  ],
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    placeOrder: (state, action) => {
      const newOrder = action.payload;
    
      // Calculate total price
      const subtotal = newOrder.items.reduce((acc, item) => acc + item.discountedPrice * item.quantity, 0);
      const gst = Math.round(0.18 * (subtotal - newOrder.couponDiscount));
    
      // Ensure the order includes billing & shipping addresses
      newOrder.totalPrice = subtotal - newOrder.couponDiscount + gst;
      newOrder.gst = gst;
      newOrder.billingAddress = action.payload.billingAddress;  // Include billing address
      newOrder.shippingAddress = action.payload.shippingAddress; // Include shipping address
    
      state.items.push(newOrder);
    },
    

    updateOrderStatus: (state, action) => {
      const { orderId, status } = action.payload;
      const orderIndex = state.items.findIndex(order => order.id === orderId);
      if (orderIndex !== -1) {
        state.items[orderIndex].status = status;
      }
    },

    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
  },
});

export const { placeOrder, updateOrderStatus, setPaymentMethod } = ordersSlice.actions;
export default ordersSlice.reducer;
